import { usePlatformDesigner } from "@/lib/usePlatformDesigner";
import { Navigate } from "react-router-dom";

/** Legacy `/disenador/centro-bnt` — redirect al Centro de Licencias BNT canónico (Fase 1). */
export default function DesignerPlatformHub() {
  const isPlatformDesigner = usePlatformDesigner();
  if (!isPlatformDesigner) {
    return <Navigate to="/disenador/inicio" replace />;
  }
  return <Navigate to="/platform" replace />;
}
